import { IconoirComputer, IconoirFastLeftCircle } from '@ey-xd/motif-icon';
import { MotifIcon, MotifVerticalNavigation, MotifVerticalNavigationContent, MotifVerticalNavigationContextSwitcher, MotifVerticalNavigationFooter, MotifVerticalNavigationMenu, MotifVerticalNavigationMenuItem, MotifVerticalNavigationSubmenu } from '@ey-xd/motif-react';
import React from 'react';
import Sticky from 'react-stickynode';

import iconSvg from "../../assets/icons/icon.svg.json";
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

interface Props {
    // Define your component's props here
}

const LeftNavigation: React.FC<Props> = (props) => {

    // Component logic goes here
    const navigate = useNavigate();
    const location = useLocation();
    const { userDetails } = useSelector((state: any) => state.user);

    return (
        <div style={{ zIndex: 1, position: "relative" }}>
            <Sticky enabled={true} top={40} bottomBoundary={"#app-footer"}>
                <MotifVerticalNavigation
                    className="left-navigation"
                >
                    <MotifVerticalNavigationContent>
                        <MotifVerticalNavigationMenu>
                            <MotifVerticalNavigationMenuItem
                                icon={<MotifIcon src={iconSvg["home-icon"]} className="w-5" title='Home' />}
                                label="Home"
                                onClick={() => {
                                    navigate('/');
                                }}
                                className={location.pathname === "/" ? "active" : ""}
                            >
                                Home
                            </MotifVerticalNavigationMenuItem>
                            <MotifVerticalNavigationMenuItem
                                icon={<MotifIcon src={iconSvg["workspace-icon"]} className="w-5" title='Workspace' />}
                                label="Workspace"
                                onClick={() => {
                                    navigate('/workspace');
                                }}
                                className={location.pathname.split('/')[1] === 'workspace' ? "active" : ""}
                            >
                                Workspace
                            </MotifVerticalNavigationMenuItem>
                            <MotifVerticalNavigationMenuItem
                                icon={<MotifIcon src={iconSvg["services-icon"]} className="w-5" title='Services' />}
                                label="Services"
                                onClick={() => { }}
                            >
                                Services
                            </MotifVerticalNavigationMenuItem>

                            {userDetails?.isAdmin !== undefined && (
                                <>
                                    {userDetails?.isAdmin === true && (
                                        <>
                                            <hr className="my-2 !border-[#86868669]" />
                                            <MotifVerticalNavigationMenuItem
                                                icon={<MotifIcon src={iconSvg["privilege-icon"]} className="w-5" title='Privileges' />}
                                                label="Privileges"
                                                onClick={() => {
                                                    navigate('/privileges');
                                                }}
                                                className={location.pathname.split('/')[1] === 'privileges' ? "active" : ""}
                                            >
                                                Privileges
                                            </MotifVerticalNavigationMenuItem>
                                            <MotifVerticalNavigationMenuItem
                                                icon={<MotifIcon src={iconSvg["user-role-icon"]} className="w-5" title='User roles' />}
                                                label="User roles"
                                                onClick={() => {
                                                    navigate('/admin/user-roles');
                                                }}
                                                className={location.pathname.includes('/admin/user-roles') ? "active" : ""}
                                            >
                                                User roles
                                            </MotifVerticalNavigationMenuItem>
                                            <MotifVerticalNavigationMenuItem
                                                icon={<MotifIcon src={iconSvg["user-group-icon"]} className="w-5" title='User groups' />}
                                                label="User groups"
                                                onClick={() => {
                                                    navigate('/admin/user-groups');
                                                }}
                                                className={location.pathname.includes('/admin/user-groups') ? "active" : ""}
                                            >
                                                User groups
                                            </MotifVerticalNavigationMenuItem>
                                            <MotifVerticalNavigationMenuItem
                                                icon={<MotifIcon src={iconSvg["admin-user-icon"]} className="w-5" title='Add user' />}
                                                label="Add user"
                                                onClick={() => {
                                                    navigate('/admin/users');
                                                }}
                                                className={location.pathname.includes('/admin/users') ? "active" : ""}
                                            >
                                                Add user
                                            </MotifVerticalNavigationMenuItem>
                                            <MotifVerticalNavigationMenuItem
                                                icon={<MotifIcon src={iconSvg["approval-check-icon"]} className="w-5" title='Approvals' />}
                                                label="Approvals"
                                                onClick={() => {
                                                    navigate('/admin/approvals');
                                                }}
                                                className={location.pathname.includes('/admin/approvals') ? "active" : ""}
                                            >
                                                Approvals
                                            </MotifVerticalNavigationMenuItem>
                                            <MotifVerticalNavigationMenuItem
                                                icon={<MotifIcon src={iconSvg["info-icon"]} className="w-5" title='Trainings' />}
                                                label="Trainings"
                                                onClick={() => {
                                                    navigate('/admin/trainings');
                                                }}
                                                className={location.pathname.includes('/admin/trainings') ? "active" : ""}
                                            >
                                                Trainings
                                            </MotifVerticalNavigationMenuItem>
                                        </>
                                    )}
                                </>
                            )}
                        </MotifVerticalNavigationMenu>
                    </MotifVerticalNavigationContent>
                    <MotifVerticalNavigationFooter>
                        <MotifVerticalNavigationMenuItem
                            icon={<MotifIcon src={iconSvg["settings-icon"]} className="w-5" title='Settings' />}
                            label="Settings"
                            onClick={() => { }}
                        >
                            Settings
                        </MotifVerticalNavigationMenuItem>
                        <MotifVerticalNavigationMenuItem
                            icon={<MotifIcon src={iconSvg["faq-icon"]} className="w-5" title='FAQ' />}
                            label="FAQ"
                            onClick={() => { }}
                        >
                            FAQ
                        </MotifVerticalNavigationMenuItem>
                        <MotifVerticalNavigationMenuItem
                            icon={<MotifIcon src={iconSvg["privacy-policy-icon"]} className="w-5" title='Privacy policy' />}
                            label="Privacy policy"
                            onClick={() => { }}
                        >
                            Privacy policy
                        </MotifVerticalNavigationMenuItem>
                    </MotifVerticalNavigationFooter>
                </MotifVerticalNavigation>
            </Sticky>
        </div>
    );
};

export default LeftNavigation;